// Intentionally blank: iOS opens this layout-less route (`_` suffix) with URL
// params so a routed dialog can render on top of an empty canvas.
const WebviewDialogPage = () => {
  return null;
};

export default WebviewDialogPage;
